import { Pipe, PipeTransform } from '@angular/core';
import { LangPrefixService } from '@services';

@Pipe({
    name: 'outletLink',
})
export class OutletLinkPipe implements PipeTransform {
    constructor(private langPrefixService: LangPrefixService) {}

    transform(outlet: any): string {
        return `/${this.langPrefixService.prefix()}/${outlet.city.toLowerCase()}/${outlet.slug.toLowerCase()}`;
    }
}
